import { render, staticRenderFns } from "./SidebarMenuComponent.vue?vue&type=template&id=0cfd4a67"
import script from "./SidebarMenuComponent.vue?vue&type=script&lang=js"
export * from "./SidebarMenuComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports